(function () {
  "use strict";

  var garageData = {
    brands: [
      { id: "toyota", name: "Toyota", popular: true },
      { id: "vw", name: "VW", popular: true },
      { id: "ford", name: "Ford", popular: true },
      { id: "renault", name: "Renault", popular: true },
      { id: "fiat", name: "Fiat", popular: true },
      { id: "hyundai", name: "Hyundai", popular: true },
      { id: "bmw", name: "BMW", popular: true },
      { id: "mercedes", name: "Mercedes", popular: true },
      { id: "honda", name: "Honda", popular: true },
      { id: "opel", name: "Opel" },
      { id: "peugeot", name: "Peugeot" },
      { id: "citroen", name: "Citroen" },
      { id: "audi", name: "Audi" },
      { id: "seat", name: "Seat" },
      { id: "skoda", name: "Skoda" },
      { id: "kia", name: "Kia" },
      { id: "nissan", name: "Nissan" },
      { id: "mazda", name: "Mazda" },
      { id: "suzuki", name: "Suzuki" },
      { id: "mini", name: "Mini" },
      { id: "dacia", name: "Dacia" }
    ],
    models: {
      toyota: ["Corolla", "Yaris", "C-HR", "RAV4", "Camry", "Auris", "Avensis", "Prius", "Hilux"],
      vw: ["Golf", "Polo", "Passat", "Tiguan", "T-Roc", "Taigo", "Arteon"],
      ford: ["Focus", "Fiesta", "Kuga", "Puma", "Mondeo", "Tourneo Courier"],
      renault: ["Clio", "Megane", "Captur", "Austral", "Kadjar", "Talisman"],
      fiat: ["Egea", "500", "Panda", "Doblo", "Linea", "Tipo"],
      hyundai: ["i20", "i30", "Tucson", "Bayon", "Kona", "Elantra"],
      bmw: ["1 Serisi", "3 Serisi", "X1", "X3", "X5", "5 Serisi"],
      mercedes: ["A Serisi", "C Serisi", "GLA", "GLC", "E Serisi", "CLA", "GLB"],
      honda: ["Civic", "Jazz", "HR-V", "CR-V", "Accord", "City"],
      opel: ["Corsa", "Astra", "Mokka", "Grandland"],
      peugeot: ["208", "308", "2008", "3008"],
      citroen: ["C3", "C4", "C5 Aircross", "Berlingo"],
      audi: ["A3", "A4", "Q2", "Q3", "Q5", "A6"],
      seat: ["Ibiza", "Leon", "Arona", "Ateca"],
      skoda: ["Fabia", "Scala", "Octavia", "Karoq", "Superb"],
      kia: ["Rio", "Ceed", "Stonic", "Sportage", "Niro"],
      nissan: ["Micra", "Juke", "Qashqai", "X-Trail", "Note"],
      mazda: ["Mazda2", "Mazda3", "CX-3", "CX-5"],
      suzuki: ["Swift", "Baleno", "Vitara", "S-Cross"],
      mini: ["Cooper", "Countryman", "Clubman", "Paceman"],
      dacia: ["Sandero", "Jogger", "Duster", "Lodgy"]
    },
    years: ["2026", "2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"],
    engines: [
      { id: "hybrid", name: "1.5 Hybrid (116 HP)", detail: "Otomatik - Benzin/Elektrik", tire: "185/65R15" },
      { id: "petrol72", name: "1.0 (72 HP)", detail: "Manuel - Benzin", tire: "175/65R15" },
      { id: "petrol125", name: "1.5 (125 HP)", detail: "CVT - Benzin", tire: "185/60R16" },
      { id: "diesel90", name: "1.4 D-4D (90 HP)", detail: "Manuel - Dizel", tire: "185/65R15" },
      { id: "turbo130", name: "1.2 Turbo (130 HP)", detail: "Otomatik - Benzin", tire: "195/55R16" },
      { id: "hybridplus", name: "1.8 Hybrid (140 HP)", detail: "e-CVT - Benzin/Elektrik", tire: "205/55R16" }
    ],
    tireSizes: []
  };

  var state = {
    step: 0,
    brand: null,
    model: null,
    modelName: null,
    modelId: null,
    year: null,
    engine: null,
    selectedTire: null,
    tireSizesEngineId: null,
    engineManualOpen: false,
    creatingVehicle: false,
    manualConstructionMenuOpen: false,
    manualTire: { width: "", aspect: "", rim: "", construction: "R" },
    showAllBrands: false,
    lockAllBrands: false
  };
  var GARAGE_MAX_VEHICLES = 6;
  var GARAGE_DEPENDENT_OVERLAY_SELECTOR = [
    "[data-registration-overlay]",
    "[data-order-success-overlay]",
    "[data-size-detect-overlay]",
    "[data-delete-confirm-overlay]",
    "[data-edit-vehicle-overlay]",
    "[data-vehicle-limit-overlay]",
    "[data-vehicle-saved-overlay]",
    "[data-vehicle-saved-active-overlay]"
  ].join(", ");
  var tireConstructionOptions = (window.GARAGE_TIRE_CONSTRUCTION_OPTIONS || ["R", "D", "B"]).filter(function (item) {
    return typeof item === "string" && item.trim();
  }).map(function (item) {
    return item.trim().toUpperCase();
  });
  if (!tireConstructionOptions.length) tireConstructionOptions = ["R"];
  function isPagesView() {
    return window.location.pathname.indexOf("/pages/") !== -1;
  }

  function garagePageHref() {
    return window.KOLAYOTO_GARAGE_PAGE_URL || "/pages/garajim";
  }

  function assetHref(path) {
    var fileName = String(path || "").split("/").pop();
    if (window.KOLAYOTO_GARAGE_ASSETS && window.KOLAYOTO_GARAGE_ASSETS[fileName]) {
      return window.KOLAYOTO_GARAGE_ASSETS[fileName];
    }
    return isPagesView() ? ("../" + path) : path;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, "&#096;");
  }

  function tireSizeValueFromApi(size) {
    if (!size) return "";

    var rawValue = size.tire_value || size.tire || size.value || "";
    if (!rawValue && size.width && size.aspect_ratio && size.diameter) {
      rawValue = String(size.width) + "/" + String(size.aspect_ratio) + "R" + String(size.diameter);
    }

    return String(rawValue || "");
  }

  function tireSizeOptionsFromApi(sizes) {
    var seen = {};

    return (sizes || []).map(function (size) {
      var rawValue = tireSizeValueFromApi(size);

      return {
        id: String(size.id || rawValue || ""),
        value: String(rawValue || ""),
        label: String(rawValue || ""),
        isStock: Boolean(size.is_stock),
        loadIndex: size.load_index || "",
        speedIndex: size.speed_index || ""
      };
    }).filter(function (size) {
      if (!size.value || seen[size.value]) return false;
      seen[size.value] = true;
      return true;
    });
  }

  function preferredTireSizeOption(sizes) {
    return sizes.find(function (size) {
      return size.isStock;
    }) || sizes[0] || null;
  }

  function setLoadingButton(button, isLoading, loadingText) {
    if (!button) return;

    if (isLoading) {
      if (!button.dataset.originalLabel) {
        button.dataset.originalLabel = button.textContent.trim();
      }
      button.classList.add("is-loading");
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.innerHTML = '<span>' + escapeHtml(loadingText || "Yükleniyor") + '</span>';
      return;
    }

    button.classList.remove("is-loading");
    button.disabled = false;
    button.removeAttribute("aria-busy");
    if (button.dataset.originalLabel) {
      button.textContent = button.dataset.originalLabel;
      delete button.dataset.originalLabel;
    }
  }

  var garageApiBase = String(window.KOLAYOTO_GARAGE_PROXY_URL || "/apps/garage").replace(/\/$/, "");
  var GARAGE_TEST_CODE_STORAGE_KEY = "kolayoto_garage_test_code";
  var GARAGE_STATE_CACHE_STORAGE_KEY = "kolayoto_garage_state_cache_v1";
  var GARAGE_STATE_CACHE_TTL = 15 * 60 * 1000;
  var referenceState = {
    brandsLoaded: false,
    modelsLoading: false,
    yearsLoading: false,
    enginesLoading: false,
    tireSizesLoading: false
  };
  var garageState = {
    activeId: null,
    activatingId: null,
    authenticated: false,
    available: null,
    loaded: false,
    testPreview: false,
    vehicles: []
  };
  var garageMenuForceEmptyPreview = false;
  var garageBootstrapConsumed = false;

  function applyGarageStateFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var forceEmpty = params.get("empty") === "1" || params.get("garage") === "empty";
      if (!forceEmpty) return;
      garageState.activeId = null;
      garageState.vehicles = [];
    } catch (error) {
      /* no-op */
    }
  }

  function garageTestCodeFromUrl() {
    try {
      return new URLSearchParams(window.location.search || "").get("test_code") || "";
    } catch (error) {
      return "";
    }
  }

  function garageTestDisabledFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      var value = String(params.get("garage_test") || params.get("garage_test_mode") || "").toLowerCase();

      return params.get("clear_garage_test") === "1" ||
        value === "0" ||
        value === "off" ||
        value === "false" ||
        value === "clear";
    } catch (error) {
      return false;
    }
  }

  function storedGarageTestCode() {
    try {
      return window.localStorage ? String(window.localStorage.getItem(GARAGE_TEST_CODE_STORAGE_KEY) || "") : "";
    } catch (error) {
      return "";
    }
  }

  function currentGarageTestCode() {
    if (garageTestDisabledFromUrl()) return "";

    return garageTestCodeFromUrl() || storedGarageTestCode();
  }

  function persistGarageTestCode(code) {
    if (!code) return;
    try {
      if (window.localStorage) window.localStorage.setItem(GARAGE_TEST_CODE_STORAGE_KEY, code);
    } catch (error) {
      /* no-op */
    }
  }

  function clearStoredGarageTestCode() {
    try {
      if (window.localStorage) window.localStorage.removeItem(GARAGE_TEST_CODE_STORAGE_KEY);
    } catch (error) {
      /* no-op */
    }
  }

  function currentGarageCustomerId() {
    try {
      return window.theme && window.theme.customer && window.theme.customer.id ? String(window.theme.customer.id) : "";
    } catch (error) {
      return "";
    }
  }

  function garageStateCacheKey() {
    var customerId = currentGarageCustomerId();
    return customerId ? GARAGE_STATE_CACHE_STORAGE_KEY + ":" + customerId : "";
  }

  function readCachedGaragePayload() {
    var cacheKey = garageStateCacheKey();
    if (!cacheKey) return null;

    try {
      if (!window.localStorage) return null;
      var raw = window.localStorage.getItem(cacheKey);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (!cached || !cached.payload || !cached.savedAt) return null;
      if (Date.now() - Number(cached.savedAt) > GARAGE_STATE_CACHE_TTL) return null;
      return cached.payload;
    } catch (error) {
      return null;
    }
  }

  function writeCachedGaragePayload(payload) {
    var cacheKey = garageStateCacheKey();
    if (!cacheKey || !payload || !payload.authenticated || payload.enabled === false) return;

    try {
      if (!window.localStorage) return;
      window.localStorage.setItem(cacheKey, JSON.stringify({
        savedAt: Date.now(),
        payload: {
          enabled: true,
          authenticated: true,
          mode: payload.mode || "",
          vehicles: payload.vehicles || [],
          active_vehicle: payload.active_vehicle || null,
          limits: payload.limits || null
        }
      }));
    } catch (error) {
      /* no-op */
    }
  }

  function clearCachedGaragePayload() {
    var cacheKey = garageStateCacheKey();
    if (!cacheKey) return;

    try {
      if (window.localStorage) window.localStorage.removeItem(cacheKey);
    } catch (error) {
      /* no-op */
    }
  }

  function shouldShowInitialGarageLoading() {
    return Boolean(currentGarageTestCode());
  }

  function garageApiUrl(path) {
    var url = garageApiBase + (path || "");
    var testCode = currentGarageTestCode();

    if (!testCode) return url;

    return url + (url.indexOf("?") === -1 ? "?" : "&") + "test_code=" + encodeURIComponent(testCode);
  }

  function uniqueElements(items) {
    var seen = [];
    items.forEach(function (item) {
      if (item && seen.indexOf(item) === -1) seen.push(item);
    });
    return seen;
  }

  function garageHeaderShells() {
    var shells = [];
    document.querySelectorAll("[data-garage-header-shell]").forEach(function (shell) {
      shells.push(shell);
    });
    document.querySelectorAll("[data-garage-header-root]").forEach(function (root) {
      shells.push(root.closest("[data-garage-header-shell]") || root.closest(".garage-header-shortcut") || root);
    });
    return uniqueElements(shells);
  }

  function garageMenuEls() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-garage-menu]"));
  }

  function visibleGarageToggleButton() {
    var buttons = Array.prototype.slice.call(document.querySelectorAll("[data-garage-modal-open]"));
    return buttons.find(function (button) {
      return button.offsetParent !== null || button.getClientRects().length > 0;
    }) || buttons[0] || null;
  }

  function setGarageHeaderVisible(visible) {
    garageHeaderShells().forEach(function (shell) {
      shell.hidden = !visible;
    });
  }

  function setGarageWidgetsVisible(visible) {
    document.querySelectorAll("[data-garage-collection-widget]").forEach(function (widget) {
      widget.hidden = !visible;
      if (!visible) widget.innerHTML = "";
    });
  }

  function activateAccountPanel(name) {
    var targetName = name || "orders";
    document.querySelectorAll("[data-account-tab]").forEach(function (tab) {
      tab.classList.toggle("is-active", tab.getAttribute("data-account-tab") === targetName);
    });
    document.querySelectorAll("[data-account-panel]").forEach(function (panel) {
      panel.classList.toggle("is-active", panel.getAttribute("data-account-panel") === targetName);
    });
  }

  function setGarageAccountVisible(visible) {
    document.querySelectorAll("[data-garage-account-page]").forEach(function (page) {
      page.hidden = !visible;
    });

    var garageTab = document.querySelector('[data-account-tab="garage"]');
    var garagePanel = document.querySelector('[data-account-panel="garage"]');
    if (garageTab) garageTab.hidden = !visible;
    if (garagePanel) garagePanel.hidden = !visible;

    if (!visible && garagePanel && garagePanel.classList.contains("is-active")) {
      activateAccountPanel(document.querySelector('[data-account-panel="orders"]') ? "orders" : "profile");
      if (window.location.hash === "#garage") {
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
      }
    }
  }

  function setGarageSurfacesVisible(visible) {
    setGarageHeaderVisible(visible);
    setGarageWidgetsVisible(visible);
    setGarageAccountVisible(visible);
    if (els.overlay) {
      els.overlay.hidden = !visible;
      if (!visible) {
        els.overlay.classList.remove("is-open");
        els.overlay.setAttribute("aria-hidden", "true");
      }
    }
    if (!visible) {
      document.querySelectorAll(GARAGE_DEPENDENT_OVERLAY_SELECTOR).forEach(function (overlay) {
        if (!overlay.classList.contains("is-open")) return;
        overlay.classList.remove("is-open");
        overlay.setAttribute("aria-hidden", "true");
      });
      if (!document.querySelector(".registration-overlay.is-open")) {
        document.body.classList.remove("registration-modal-open");
      }
    }
    document.documentElement.classList.toggle("garage-api-unavailable", !visible);
  }

  function emitGarageAvailability(available) {
    document.dispatchEvent(new CustomEvent("garage:availability-changed", {
      detail: { available: available }
    }));
  }

  function markGarageAvailable() {
    garageState.available = true;
    setGarageSurfacesVisible(true);
    emitGarageAvailability(true);
  }

  function markGarageUnavailable() {
    garageState.available = false;
    garageState.authenticated = false;
    garageState.loaded = true;
    garageState.vehicles = [];
    garageState.activeId = null;
    garageState.activatingId = null;
    garageState.testPreview = false;
    garageMenuForceEmptyPreview = false;
    closeGarageMenu();
    closeModal();
    setGarageSurfacesVisible(false);
    emitGarageAvailability(false);
  }

  function isGarageUnavailableError(error) {
    if (!error || !error.response) return true;
    var status = Number(error.response.status || 0);
    if (error.parseError && status >= 200 && status < 300) return true;
    return status === 0 || status === 403 || status === 404 || status >= 500;
  }

  function hydrateGuestGarage() {
    markGarageAvailable();
    garageState.authenticated = false;
    garageState.loaded = true;
    garageState.vehicles = [];
    garageState.activeId = null;
    garageState.activatingId = null;
    garageState.testPreview = false;
    updateGarageButtons();
    renderGarageMenu();
    renderCollectionWidgets();
    renderGarageAccount();
  }

  function garageRequest(path, options) {
    var requestOptions = options || {};
    requestOptions.cache = requestOptions.cache || "no-store";
    requestOptions.credentials = "same-origin";
    requestOptions.headers = Object.assign({
      "Accept": "application/json"
    }, requestOptions.headers || {});

    if (requestOptions.body && !requestOptions.headers["Content-Type"]) {
      requestOptions.headers["Content-Type"] = "application/json";
    }

    return fetch(garageApiUrl(path), requestOptions).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        if (text) {
          try {
            data = JSON.parse(text);
          } catch (parseError) {
            parseError.response = response;
            parseError.parseError = true;
            throw parseError;
          }
        }
        if (!response.ok) {
          var error = new Error((data && data.message) || "Garage request failed");
          error.response = response;
          error.data = data;
          throw error;
        }
        return data;
      });
    }).catch(function (error) {
      if (isGarageUnavailableError(error)) {
        markGarageUnavailable();
      }
      throw error;
    });
  }

  function vehicleImageFromApi(vehicle) {
    var metadata = vehicle.metadata && typeof vehicle.metadata === "object" ? vehicle.metadata : {};
    var imageUrl = vehicle.image_url ||
      vehicle.image ||
      vehicle.photo_url ||
      metadata.image_url ||
      metadata.image ||
      metadata.vehicle_image_url;

    return imageUrl ? String(imageUrl) : assetHref("assets/images/sample-car.png");
  }

  function tirePartsFromApi(vehicle) {
    var tire = vehicle && vehicle.primary_tire && typeof vehicle.primary_tire === "object" ? vehicle.primary_tire : {};
    var value = tire.value || (vehicle && vehicle.primary_tire_size) || "";
    var width = tire.width == null ? "" : String(tire.width);
    var aspect = tire.aspect_ratio == null ? "" : String(tire.aspect_ratio);
    var construction = tire.construction ? String(tire.construction).toUpperCase() : "R";
    var rim = tire.diameter == null ? "" : String(tire.diameter);

    return {
      value: String(value || ""),
      width: width,
      aspect: aspect,
      construction: construction,
      rim: rim
    };
  }

  function tireDisplayFromParts(parts) {
    if (!parts) return "";
    if (parts.width && parts.aspect && parts.rim) {
      return parts.width + "/" + parts.aspect + (parts.construction || "R") + parts.rim;
    }
    return parts.value || "";
  }

  function mapVehicleFromApi(vehicle) {
    var tireParts = tirePartsFromApi(vehicle);
    var tireDisplay = tireDisplayFromParts(tireParts);

    return {
      id: String(vehicle.id),
      apiId: vehicle.id,
      brand: vehicle.make_name || "",
      model: vehicle.model_name || "",
      year: vehicle.year ? String(vehicle.year) : "",
      engineName: vehicle.engine_name || "",
      tire: tireParts.value || "",
      tireDisplay: tireDisplay,
      tireParts: tireParts,
      productsUrl: vehicle.products_url || "",
      image: vehicleImageFromApi(vehicle),
      nickname: vehicle.label || "",
      displayName: vehicle.display_name || "",
      plate: vehicle.plate || "",
      km: vehicle.current_km == null ? "" : String(vehicle.current_km),
      lastTireChange: vehicle.last_tire_change_date || "",
      isPrimary: Boolean(vehicle.is_primary)
    };
  }

  function vehicleMakeModel(vehicle) {
    return [vehicle.brand, vehicle.model].filter(Boolean).join(" ");
  }

  function vehicleTitle(vehicle) {
    return vehicle.nickname || vehicleMakeModel(vehicle) || vehicle.displayName || "Aracım";
  }

  function vehicleMeta(vehicle) {
    return [vehicle.year, vehicle.engineName, vehicle.tireDisplay || vehicle.tire].filter(Boolean).join(" • ");
  }

  function tireFilterParts(tire) {
    var match = String(tire || "").toUpperCase().replace(/\s+/g, "").match(/(\d{2,3})\/(\d{2})([A-Z]?)(\d{2})/);
    if (!match) return null;
    var construction = match[3] || "R";
    return {
      width: match[1],
      aspect: match[2],
      construction: construction,
      rim: match[4],
      value: match[1] + "/" + match[2] + construction + match[4]
    };
  }

  function normalizedTireFilterValue(value) {
    var parts = tireFilterParts(value);
    return parts ? parts.value : "";
  }

  function tireFilterPartsFromVehicle(vehicle) {
    if (vehicle && vehicle.tireParts && vehicle.tireParts.width && vehicle.tireParts.aspect && vehicle.tireParts.rim) {
      return {
        width: vehicle.tireParts.width,
        aspect: vehicle.tireParts.aspect,
        construction: vehicle.tireParts.construction || "R",
        rim: vehicle.tireParts.rim,
        value: vehicle.tireParts.width + "/" + vehicle.tireParts.aspect + (vehicle.tireParts.construction || "R") + vehicle.tireParts.rim
      };
    }

    return tireFilterParts(vehicle && vehicle.tire);
  }

  function isVehicleTireFilterActive(vehicle) {
    var parts = tireFilterPartsFromVehicle(vehicle);
    if (!parts) return false;

    var params = new URLSearchParams(window.location.search);
    var querySize = normalizedTireFilterValue(String(params.get("q") || "").replace(/\*/g, ""));
    if (querySize === parts.value) return true;

    var activeSize = params.getAll("filter.p.m.filtre.ebat").some(function (value) {
      return normalizedTireFilterValue(value) === parts.value;
    });
    if (activeSize) return true;

    var width = params.get("filter.p.m.filtre.taban_genisligi");
    var aspect = params.get("filter.p.m.filtre.kesit_orani");
    var rim = params.get("filter.p.m.filtre.jant_capi");
    if (width === parts.width && aspect === parts.aspect && rim === parts.rim) return true;

    return false;
  }

  function updateVehicleFilteredSearchTitle(activeVehicle) {
    if (window.location.pathname.indexOf("/search") !== 0) return;

    var title = document.querySelector(".template-search .section-header .section-title");
    if (!title) return;

    if (!title.dataset.garageOriginalTitle) {
      title.dataset.garageOriginalTitle = title.textContent.trim();
    }

    if (activeVehicle && isVehicleTireFilterActive(activeVehicle)) {
      title.textContent = "Aracınıza Uygun Sonuçlar";
      title.dataset.garageVehicleFilteredTitle = "true";
      return;
    }

    if (title.dataset.garageVehicleFilteredTitle === "true" && title.dataset.garageOriginalTitle) {
      title.textContent = title.dataset.garageOriginalTitle;
      delete title.dataset.garageVehicleFilteredTitle;
    }
  }

  function scheduleVehicleFilterStateUpdate() {
    window.setTimeout(function () {
      if (garageState.available === true && garageState.loaded) {
        renderCollectionWidgets();
        return;
      }

      updateVehicleFilteredSearchTitle(getActiveVehicle());
    }, 0);
  }

  function vehicleTireFilterUrl(vehicle) {
    var parts = tireFilterPartsFromVehicle(vehicle);
    if (!parts) return (vehicle && vehicle.productsUrl) || window.KOLAYOTO_GARAGE_COLLECTION_URL || "/collections/lastikleri";

    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return (vehicle && vehicle.productsUrl) || window.KOLAYOTO_GARAGE_COLLECTION_URL || "/collections/lastikleri";
    }

    var params = url.searchParams;
    params.delete("page");
    params.delete("q");
    params.delete("filter.p.m.filtre.taban_genisligi");
    params.delete("filter.p.m.filtre.kesit_orani");
    params.delete("filter.p.m.filtre.jant_capi");
    params.set("filter.v.availability", "1");
    params.set("filter.p.m.filtre.ebat", parts.value);

    if (url.pathname.indexOf("/search") === 0) {
      params.set("type", "product");
      params.set("options[unavailable_products]", "last");
      params.set("options[prefix]", "none");
    }

    return url.pathname + url.search + url.hash;
  }

  function vehicleImageAlt(vehicle) {
    return vehicleMakeModel(vehicle) || vehicleTitle(vehicle);
  }

  function hydrateGarage(payload, options) {
    if (!payload) return;
    if (payload.enabled === false) {
      if (payload.mode === "test") clearStoredGarageTestCode();
      clearCachedGaragePayload();
      markGarageUnavailable();
      return;
    }

    markGarageAvailable();
    garageState.testPreview = payload.mode === "test";
    if (garageState.testPreview) persistGarageTestCode(currentGarageTestCode());
    garageState.authenticated = Boolean(payload.authenticated);
    garageState.loaded = true;
    garageState.vehicles = (payload.vehicles || []).map(mapVehicleFromApi);
    var activeVehicle = payload.active_vehicle ? mapVehicleFromApi(payload.active_vehicle, 0) : null;
    garageState.activeId = activeVehicle ? activeVehicle.id : null;
    if (!garageState.activeId) {
      var primary = garageState.vehicles.find(function (vehicle) {
        return vehicle.isPrimary;
      });
      garageState.activeId = primary ? primary.id : (garageState.vehicles[0] ? garageState.vehicles[0].id : null);
    }
    if (payload.limits && payload.limits.max_vehicles) {
      GARAGE_MAX_VEHICLES = Number(payload.limits.max_vehicles) || GARAGE_MAX_VEHICLES;
    }
    if (!options || !options.fromCache) writeCachedGaragePayload(payload);
    updateGarageButtons();
    renderGarageMenu();
    renderCollectionWidgets();
    renderGarageAccount();
  }

  function hydrateGarageFromCache() {
    var cachedPayload = readCachedGaragePayload();
    if (!cachedPayload) return false;
    hydrateGarage(cachedPayload, { fromCache: true });
    return true;
  }

  function refreshGarage() {
    var bootstrapRequest = consumeGarageBootstrap();
    if (bootstrapRequest) return bootstrapRequest;

    return garageRequest("").then(hydrateGarage).catch(function (error) {
      if (isGarageUnavailableError(error)) {
        markGarageUnavailable();
        return;
      }
      hydrateGuestGarage();
    });
  }

  function consumeGarageBootstrap() {
    var bootstrapRequest = window.KOLAYOTO_GARAGE_BOOTSTRAP;

    if (garageBootstrapConsumed || !bootstrapRequest || typeof bootstrapRequest.then !== "function") return null;
    garageBootstrapConsumed = true;

    return bootstrapRequest.then(hydrateGarage).catch(function (error) {
      if (isGarageUnavailableError(error)) {
        markGarageUnavailable();
        return;
      }
      hydrateGuestGarage();
    });
  }

  function loadBrands() {
    if (referenceState.brandsLoaded) return Promise.resolve();
    return garageRequest("/references/makes").then(function (payload) {
      garageData.brands = (payload.data || []).map(function (brand, index) {
        return {
          id: String(brand.id),
          name: brand.name,
          popular: index < 9
        };
      });
      referenceState.brandsLoaded = true;
    });
  }

  function loadModelsForMake(makeId) {
    referenceState.modelsLoading = true;
    garageData.models[makeId] = [];
    return garageRequest("/references/makes/" + encodeURIComponent(makeId) + "/models").then(function (payload) {
      garageData.models[makeId] = (payload.data || []).map(function (model) {
        return {
          id: String(model.slug || model.id),
          name: model.name,
          slug: model.slug || model.id
        };
      });
    }).finally(function () {
      referenceState.modelsLoading = false;
      if (state.step === 1) render();
    });
  }

  function loadYearsForModel(makeId, modelId) {
    referenceState.yearsLoading = true;
    garageData.years = [];
    return garageRequest("/references/makes/" + encodeURIComponent(makeId) + "/models/" + encodeURIComponent(modelId) + "/years").then(function (payload) {
      garageData.years = (payload.data || []).map(function (year) {
        return {
          id: String(year.id),
          year: String(year.year),
          modelId: String(year.model_id)
        };
      });
    }).finally(function () {
      referenceState.yearsLoading = false;
      if (state.step === 2) render();
    });
  }

  function loadEnginesForModel(modelId) {
    if (!modelId) return Promise.resolve();
    referenceState.enginesLoading = true;
    referenceState.tireSizesLoading = false;
    garageData.engines = [];
    garageData.tireSizes = [];
    return garageRequest("/references/models/" + encodeURIComponent(modelId) + "/engines").then(function (payload) {
      garageData.engines = (payload.data || []).map(function (engine) {
        return {
          id: String(engine.id),
          name: engine.name,
          detail: "",
          tire: "",
          tireOptions: []
        };
      });
    }).finally(function () {
      referenceState.enginesLoading = false;
      if (state.step === 3) render();
    });
  }

  function loadTireSizesForEngine(engineId) {
    var normalizedEngineId = String(engineId || "");
    state.tireSizesEngineId = normalizedEngineId;
    state.selectedTire = null;
    garageData.tireSizes = [];
    state.engineManualOpen = false;
    referenceState.tireSizesLoading = false;

    if (!/^\d+$/.test(normalizedEngineId)) {
      if (state.engine && state.engine.tire) {
        garageData.tireSizes = [{
          id: "stock-" + state.engine.tire,
          value: state.engine.tire,
          label: state.engine.tire,
          isStock: true
        }];
        state.selectedTire = garageData.tireSizes[0];
      } else {
        state.engineManualOpen = true;
      }
      if (state.step === 4) render();
      return Promise.resolve();
    }

    referenceState.tireSizesLoading = true;
    if (state.step === 4) render();

    return garageRequest("/references/engines/" + encodeURIComponent(normalizedEngineId) + "/oem-sizes").then(function (payload) {
      if (state.tireSizesEngineId !== normalizedEngineId) return;

      garageData.tireSizes = tireSizeOptionsFromApi(payload.data || []);

      if (garageData.tireSizes.length) {
        var stockTire = preferredTireSizeOption(garageData.tireSizes);
        state.selectedTire = stockTire;
        if (state.engine) {
          state.engine.tire = stockTire.value;
          state.engine.tireOptions = garageData.tireSizes.slice();
        }
      } else {
        state.engineManualOpen = true;
      }
    }).catch(function () {
      if (state.tireSizesEngineId !== normalizedEngineId) return;
      state.engineManualOpen = true;
    }).finally(function () {
      if (state.tireSizesEngineId !== normalizedEngineId) return;
      referenceState.tireSizesLoading = false;
      if (state.step === 4) render();
    });
  }

  var els = {};
  var stepTitles = [
    "Aracının markasını seç",
    "Modelini seç",
    "Yılını seç",
    "Motor tipini seç",
    "Lastik ebatını seç",
    ""
  ];

  function icon(name) {
    if (name === "x") {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';
    }
    if (name === "search") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.7504 15.7504L12.5254 12.5254" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "check") {
      return '<svg class="garage-modal-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="m20 6-11 11-5-5"></path></svg>';
    }
    if (name === "statusCheck") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none" aria-hidden="true"><path d="M14.3333 1L5.16667 10.1667L1 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "trash") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true"><path d="M6 1H11M1 3.5H16M14.3333 3.5L13.7489 12.2661C13.6612 13.5813 13.6174 14.2389 13.3333 14.7375C13.0833 15.1765 12.706 15.5294 12.2514 15.7497C11.735 16 11.0759 16 9.75779 16H7.24221C5.92409 16 5.26503 16 4.74861 15.7497C4.29396 15.5294 3.91674 15.1765 3.66665 14.7375C3.38259 14.2389 3.33875 13.5813 3.25107 12.2661L2.66667 3.5M6.83333 7.25V11.4167M10.1667 7.25V11.4167" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "addVehicle") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none" aria-hidden="true"><path d="M11.4578 7.29248V15.6265M7.29126 11.4595H15.6243M21.874 11.4595C21.874 17.2129 17.2105 21.877 11.4578 21.877C5.70502 21.877 1.0415 17.2129 1.0415 11.4595C1.0415 5.70606 5.70502 1.04199 11.4578 1.04199C17.2105 1.04199 21.874 5.70606 21.874 11.4595Z" stroke="#98A2B3" stroke-width="2.08337" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "garageEmpty") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="100" viewBox="0 0 96 100" fill="none" aria-hidden="true"><path d="M52.2562 81.9956C51.6683 81.4077 50.716 81.4077 50.1281 81.9956L48 84.1237L45.872 81.9956C45.2841 81.4077 44.3317 81.4077 43.7439 81.9956C43.156 82.5834 43.156 83.5358 43.7439 84.1237L45.872 86.2517L43.7439 88.3798C43.156 88.9677 43.156 89.92 43.7439 90.5079C44.3317 91.0958 45.2841 91.0958 45.872 90.5079L48 88.3798L50.1281 90.5079C50.716 91.0958 51.6683 91.0958 52.2562 90.5079C52.8441 89.92 52.8441 88.9677 52.2562 88.3798L50.1281 86.2517L52.2562 84.1237C52.8441 83.5358 52.8441 82.5834 52.2562 81.9956Z" fill="#E2E2E2"/><path d="M8.87139 84.7473C6.93095 84.7542 6.86699 87.7319 8.87149 87.7572C8.87139 87.7572 34.5443 87.7572 34.5443 87.7572C35.2959 94.5189 41.0403 99.7968 47.9999 99.7968C54.9596 99.7968 60.704 94.5189 61.4556 87.7572H87.1285C87.9603 87.7572 88.6334 87.0834 88.6334 86.2523C88.6334 85.4212 87.9603 84.7473 87.1285 84.7473H84.8711V29.944L86.6861 30.5025C86.8331 30.548 86.983 30.5701 87.1285 30.5701C87.7722 30.5701 88.3674 30.1541 88.5673 29.5068C88.8112 28.7124 88.3659 27.8703 87.5708 27.6263L48.4423 15.5868C48.1542 15.4971 47.8456 15.4971 47.5576 15.5868L8.42901 27.6263C6.56547 28.2485 7.39224 31.0441 9.31383 30.5025C9.31375 30.5025 11.1288 29.944 11.1288 29.944V84.7473H8.87139ZM47.9999 96.7869C42.1918 96.7869 37.4653 92.0611 37.4653 86.2523C37.4359 76.178 50.5465 71.8678 56.4829 79.9997C57.6748 81.565 60.0572 79.8237 58.9019 78.208C56.3491 74.7638 52.2737 72.7078 47.9999 72.7078C41.0403 72.7078 35.2959 77.9856 34.5443 84.7473H25.4258V56.1534C25.4258 55.3223 24.7527 54.6484 23.9208 54.6484H22.4159V51.6386H73.584V54.6484H31.4455C30.6137 54.6484 29.9406 55.3223 29.9406 56.1534C29.9406 56.9845 30.6137 57.6583 31.4455 57.6583H70.5741V84.7473H60.0395C59.2077 84.7473 58.5345 85.4212 58.5345 86.2523C58.5345 92.0611 53.8081 96.7869 47.9999 96.7869ZM14.1387 29.0179L47.9999 18.5996L81.8612 29.0179V84.7473H73.584V57.6583C75.2432 57.6583 76.5939 56.3084 76.5939 54.6484V51.6386C76.5939 49.9786 75.2432 48.6287 73.584 48.6287H22.4159C20.7566 48.6287 19.406 49.9786 19.406 51.6386V54.6484C19.406 56.3084 20.7566 57.6583 22.4159 57.6583V84.7473H14.1387V29.0179Z" fill="#E2E2E2"/><path d="M38.9703 35.0323H57.0296C57.8614 35.0323 58.5346 34.3585 58.5346 33.5274C58.5346 32.6963 57.8614 32.0225 57.0296 32.0225H38.9703C36.9976 32.054 36.9877 34.9988 38.9703 35.0323Z" fill="#E2E2E2"/><path d="M54.02 39.5479H41.9804C40.0058 39.58 39.9995 42.5244 41.9805 42.5577H54.02C55.9946 42.5256 56.0009 39.5812 54.02 39.5479Z" fill="#E2E2E2"/></svg>';
    }
    if (name === "ctaArrow") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true"><path d="M0.75 4.25H7.75M7.75 4.25L4.25 0.75M7.75 4.25L4.25 7.75" stroke="#007AC1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "chevron") {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>';
    }
    if (name === "down") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6L8 10L12 6" stroke="#0089C7" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "back") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 12L6 8L10 4" stroke="#0089C7" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "menuCar") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.33301 8.66699H5.33301M1.33301 6.00033L2.66634 6.66699L3.51344 4.12571C3.68829 3.60116 3.77571 3.33889 3.93787 3.14498C4.08106 2.97375 4.26495 2.84121 4.47268 2.75951C4.70791 2.66699 4.98437 2.66699 5.53729 2.66699H10.4621C11.015 2.66699 11.2914 2.66699 11.5267 2.75951C11.7344 2.84121 11.9183 2.97375 12.0615 3.14498C12.2236 3.33889 12.3111 3.60116 12.4859 4.12571L13.333 6.66699L14.6663 6.00033M10.6663 8.66699H12.6663M4.53301 6.66699H11.4663C12.5864 6.66699 13.1465 6.66699 13.5743 6.88498C13.9506 7.07673 14.2566 7.38269 14.4484 7.75901C14.6663 8.18683 14.6663 8.74689 14.6663 9.86699V11.667C14.6663 11.9768 14.6663 12.1316 14.6407 12.2604C14.5355 12.7894 14.122 13.2028 13.5931 13.308C13.4643 13.3337 13.3094 13.3337 12.9997 13.3337H12.6663C11.93 13.3337 11.333 12.7367 11.333 12.0003C11.333 11.8162 11.1838 11.667 10.9997 11.667H4.99967C4.81558 11.667 4.66634 11.8162 4.66634 12.0003C4.66634 12.7367 4.06939 13.3337 3.33301 13.3337H2.99967C2.6899 13.3337 2.53502 13.3337 2.40622 13.308C1.8773 13.2028 1.46384 12.7894 1.35863 12.2604C1.33301 12.1316 1.33301 11.9768 1.33301 11.667V9.86699C1.33301 8.74689 1.33301 8.18683 1.55099 7.75901C1.74274 7.38269 2.0487 7.07673 2.42503 6.88498C2.85285 6.66699 3.4129 6.66699 4.53301 6.66699Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    if (name === "right") {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none" aria-hidden="true"><path d="M0.75 4.25H7.75M7.75 4.25L4.25 0.75M7.75 4.25L4.25 7.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
    return "";
  }

  function carSvg() {
    return '<svg viewBox="0 0 220 96" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M25 62c7-17 18-27 34-32 19-7 57-8 75-3 17 5 31 16 45 31l19 4c6 2 10 7 10 14v6H14v-6c0-7 4-12 11-14Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M64 31 50 59h86L119 29" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M131 31c18 5 29 15 41 28" stroke="currentColor" stroke-width="3" stroke-linecap="round"/><circle cx="57" cy="82" r="13" stroke="currentColor" stroke-width="3"/><circle cx="165" cy="82" r="13" stroke="currentColor" stroke-width="3"/><path d="M75 82h72M16 82h23M183 82h24" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>';
  }

  function getBrandName() {
    var brand = garageData.brands.find(function (item) {
      return item.id === state.brand;
    });
    return brand ? brand.name : "";
  }

  function selectedSummary() {
    var bits = [];
    if (getBrandName()) bits.push(getBrandName());
    if (state.modelName || state.model) bits.push(state.modelName || state.model);
    if (state.year) bits.push(state.year);
    if (state.step >= 4 && state.engine && state.engine.name) {
      bits.push(state.engine.name.replace(/\s*\([^)]*\)/, ""));
    }
    return bits.join(" - ");
  }

  function getActiveVehicle() {
    return garageState.vehicles.find(function (vehicle) {
      return vehicle.id === garageState.activeId;
    });
  }

  function updateGarageButtons(vehicle) {
    var isLoading = garageState.available === null;
    var showLoading = isLoading;
    if (garageState.available === false) {
      setGarageHeaderVisible(false);
      return;
    }

    setGarageHeaderVisible(true);
    var activeVehicle = isLoading ? null : (vehicle || getActiveVehicle());
    var compactEmptyGuest = garageState.loaded && !garageState.authenticated && !activeVehicle;
    document.querySelectorAll("[data-garage-modal-open]").forEach(function (button) {
      var labelEl = button.querySelector(".garage-demo-add-label");
      var shortcut = button.closest(".garage-nav-shortcut, .garage-mobile-shortcut, .garage-tablet-shortcut");
      button.classList.toggle("is-garage-loading", showLoading);
      button.classList.toggle("is-test-preview", garageState.testPreview);
      button.disabled = showLoading;
      if (showLoading) {
        button.setAttribute("aria-busy", "true");
      } else {
        button.removeAttribute("aria-busy");
      }
      if (shortcut) shortcut.classList.toggle("is-loading", showLoading);
      if (shortcut) shortcut.classList.toggle("is-empty-guest", compactEmptyGuest);
      if (showLoading) {
        if (labelEl) labelEl.textContent = "Garajım";
        button.classList.remove("is-filled");
        return;
      }
      if (!activeVehicle) {
        if (labelEl) labelEl.textContent = "Garajım";
        button.classList.remove("is-filled");
        return;
      }
      var label = vehicleTitle(activeVehicle) + (activeVehicle.tireDisplay ? " • " + activeVehicle.tireDisplay : "");
      if (labelEl) labelEl.textContent = label;
      button.classList.add("is-filled");
    });
  }

  function closeGarageMenu() {
    if (!garageMenuEls().length) return;
    garageMenuForceEmptyPreview = false;
    document.querySelectorAll(".garage-demo-garage.is-open").forEach(function (garageWrap) {
      garageWrap.classList.remove("is-open");
    });
    document.querySelectorAll("[data-garage-modal-open]").forEach(function (button) {
      button.setAttribute("aria-expanded", "false");
    });
  }

  function toggleGarageMenu(button) {
    var garage = button.closest(".garage-demo-garage");
    if (!garage) return;
    var shouldOpen = !garage.classList.contains("is-open");
    closeGarageMenu();
    if (!shouldOpen) return;
    garage.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    renderGarageMenu();
  }

  function vehicleCard(vehicle) {
    var isActive = vehicle.id === garageState.activeId;
    var isActivating = vehicle.id === garageState.activatingId;
    var title = escapeHtml(vehicleTitle(vehicle));
    var makeModel = escapeHtml(vehicleMakeModel(vehicle));
    var meta = escapeHtml(vehicleMeta(vehicle));
    var hasNickname = Boolean(vehicle.nickname);
    return '<div class="garage-menu-card ' + (isActive ? "is-active" : "") + '">' +
      '<img class="garage-menu-car" src="' + escapeAttr(vehicle.image) + '" alt="' + escapeAttr(vehicleImageAlt(vehicle)) + '">' +
      '<strong class="garage-menu-card-title">' + title + '</strong>' +
      (hasNickname && makeModel ? '<span class="garage-menu-card-model">' + makeModel + '</span>' : '') +
      (meta ? '<span class="garage-menu-card-meta">' + meta + '</span>' : '') +
      (isActive ? '<span class="garage-menu-active">Aktif <span class="garage-menu-active-icon">' + icon("statusCheck") + '</span></span>' : '<button class="garage-menu-switch' + (isActivating ? " is-loading" : "") + '" type="button" data-garage-switch="' + vehicle.id + '"' + (isActivating ? ' disabled aria-busy="true"' : '') + '><span>' + (isActivating ? "Geçiliyor" : "Geçiş Yap") + '</span>' + (isActivating ? '' : ' ' + icon("right")) + '</button>') +
      '</div>';
  }

  function renderGarageMenu() {
    var menus = garageMenuEls();
    if (!menus.length) return;
    if (garageState.available !== true) {
      menus.forEach(function (menu) {
        menu.classList.remove("is-empty");
        menu.innerHTML = "";
      });
      return;
    }
    if (garageMenuForceEmptyPreview || !garageState.vehicles.length) {
      var emptyHtml = '<div class="garage-menu-empty">' +
        '<div class="garage-menu-empty-icon" aria-hidden="true"><img src="' + assetHref("assets/svg/car-empty-modal.svg") + '" alt=""></div>' +
        '<strong class="garage-menu-empty-title">Henüz aracın yok</strong>' +
        '<p class="garage-menu-empty-text">Aracını ekle, tüm ürünler aracına göre filtrelensin. Sana özel öneriler ve fırsatları kaçırma.</p>' +
        '</div>' +
        '<div class="garage-menu-actions">' +
        '<button class="garage-menu-action is-add" type="button" data-garage-add-vehicle><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8.00016 3.33301V12.6663M3.3335 7.99967H12.6668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Araç ekle</button>' +
        '<button class="garage-menu-action is-garage" type="button" data-garage-home>' + icon("menuCar") + ' Garajım</button>' +
        '</div>';
      menus.forEach(function (menu) {
        menu.classList.add("is-empty");
        menu.innerHTML = emptyHtml;
      });
      return;
    }

    var vehicles = garageState.vehicles.slice().sort(function (a, b) {
      if (a.id === garageState.activeId) return -1;
      if (b.id === garageState.activeId) return 1;
      return 0;
    });
    var listClass = vehicles.length > 2 ? "garage-menu-list is-scroll" : "garage-menu-list";
    var menuHtml = '<div class="' + listClass + '">' + vehicles.map(vehicleCard).join("") + '</div>' +
      '<div class="garage-menu-actions">' +
      '<button class="garage-menu-action is-add" type="button" data-garage-add-vehicle><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8.00016 3.33301V12.6663M3.3335 7.99967H12.6668" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Araç ekle</button>' +
      '<button class="garage-menu-action is-garage" type="button" data-garage-home>' + icon("menuCar") + ' Garajım</button>' +
      '</div>';
    menus.forEach(function (menu) {
      menu.classList.remove("is-empty");
      menu.innerHTML = menuHtml;
    });
  }

  function renderSidebarCollectionWidget(activeVehicle) {
    if (!activeVehicle) {
      return '<article class="garage-vehicle-card garage-vehicle-card-empty">' +
        '<div class="garage-vehicle-card-empty-content">' +
        '<div class="garage-vehicle-card-empty-title-wrap">' +
        '<div class="garage-vehicle-card-empty-icon" aria-hidden="true"><img src="' + assetHref("assets/svg/car-plus.svg") + '" alt=""></div>' +
        '<h3 class="garage-vehicle-card-empty-title">Aracına uygun lastikleri gör</h3>' +
        '</div>' +
        '<p class="garage-vehicle-card-empty-desc">Marka, model ve yılını seç</p>' +
        '<button class="garage-vehicle-card-empty-cta" type="button" data-garage-open-flow><span>+</span> Aracını ekle</button>' +
        '</div>' +
        '<img class="garage-vehicle-card-empty-tire" src="' + assetHref("assets/images/tire.png") + '" alt="">' +
        '</article>';
    }

    var title = escapeHtml(vehicleTitle(activeVehicle));
    var makeModel = escapeHtml(vehicleMakeModel(activeVehicle));
    var meta = escapeHtml([activeVehicle.year, activeVehicle.engineName].filter(Boolean).join(" • "));
    var hasNickname = Boolean(activeVehicle.nickname);
    var tire = escapeHtml(activeVehicle.tireDisplay || activeVehicle.tire || "");
    var filterActive = isVehicleTireFilterActive(activeVehicle);
    var filterUrl = vehicleTireFilterUrl(activeVehicle);
    return '<article class="garage-vehicle-card garage-vehicle-card-filled ' + (filterActive ? "is-filtered" : "is-filterable") + '">' +
      '<img class="garage-vehicle-card-filled-car" src="' + escapeAttr(activeVehicle.image) + '" alt="' + escapeAttr(vehicleImageAlt(activeVehicle)) + '">' +
      '<div class="garage-vehicle-card-filled-content">' +
      '<h3>' + title + '</h3>' +
      (hasNickname && makeModel ? '<p class="garage-vehicle-card-filled-model">' + makeModel + '</p>' : '') +
      (meta ? '<p>' + meta + '</p>' : '') +
      (tire ? '<span class="garage-vehicle-card-size">' + tire + (filterActive ? ' ✓' : '') + '</span>' : "") +
      (tire && filterActive ? '<span class="garage-vehicle-card-filter-status">Aracıma uygun filtre aktif</span>' : '') +
      (tire && !filterActive ? '<button type="button" class="garage-vehicle-card-filter" data-garage-filter-url="' + escapeAttr(filterUrl) + '">Aracıma uygun filtrele</button>' : "") +
      '<button type="button" class="garage-vehicle-card-change" data-garage-open-flow>Değiştir</button>' +
      '</div>' +
      '</article>';
  }

  function renderInlineCollectionWidget() {
    return '<section class="garage-demo-banner garage-demo-banner-inline" aria-label="Araç ekleme bannerı ara konum">' +
      '<div class="garage-demo-banner-icon" aria-hidden="true"><img class="garage-demo-banner-car" src="' + assetHref("assets/svg/car-plus.svg") + '" alt=""></div>' +
      '<div class="garage-demo-banner-content">' +
      '<h2 class="garage-demo-banner-title">Aracını kaydet, aradığını hemen bul</h2>' +
      '<p class="garage-demo-banner-text">Tüm ürünler ve hizmetler aracına göre filtrelensin</p>' +
      '</div>' +
      '<button class="garage-demo-banner-cta" type="button" data-garage-open-flow><span>+</span> Aracını ekle</button>' +
      '</section>';
  }

  function renderCollectionWidgetSkeleton(variant) {
    if (variant === "inline") {
      return '<section class="garage-widget-skeleton garage-widget-skeleton--inline" aria-busy="true" aria-label="Garaj bilgisi yükleniyor">' +
        '<span class="garage-widget-skeleton-icon" aria-hidden="true"></span>' +
        '<span class="garage-widget-skeleton-content" aria-hidden="true">' +
        '<span class="garage-widget-skeleton-line is-title"></span>' +
        '<span class="garage-widget-skeleton-line is-meta"></span>' +
        '<span class="garage-widget-skeleton-line is-action"></span>' +
        '</span>' +
        '</section>';
    }

    return '<section class="garage-widget-skeleton garage-widget-skeleton--sidebar garage-widget-skeleton--vehicle" aria-busy="true" aria-label="Garaj bilgisi yükleniyor">' +
      '<span class="garage-widget-skeleton-car" aria-hidden="true"><img src="' + assetHref("assets/sample-car.png") + '" alt=""></span>' +
      '<span class="garage-widget-skeleton-content garage-widget-skeleton-content--vehicle" aria-hidden="true">' +
      '<span class="garage-widget-skeleton-line is-title"></span>' +
      '<span class="garage-widget-skeleton-line is-meta"></span>' +
      '<span class="garage-widget-skeleton-line is-size"></span>' +
      '<span class="garage-widget-skeleton-line is-action"></span>' +
      '<span class="garage-widget-skeleton-line is-change"></span>' +
      '</span>' +
      '</section>';
  }

  function renderCollectionWidgets() {
    var widgets = document.querySelectorAll("[data-garage-collection-widget]");
    if (!widgets.length) return;
    if (garageState.available === null) {
      widgets.forEach(function (widget) {
        if (!shouldShowInitialGarageLoading()) {
          widget.hidden = true;
          widget.innerHTML = "";
          return;
        }
        var variant = widget.getAttribute("data-garage-widget-variant") || "sidebar";
        widget.hidden = false;
        widget.innerHTML = renderCollectionWidgetSkeleton(variant);
      });
      return;
    }

    if (garageState.available === false) {
      widgets.forEach(function (widget) {
        widget.hidden = true;
        widget.innerHTML = "";
      });
      return;
    }

    var activeVehicle = getActiveVehicle();
    updateVehicleFilteredSearchTitle(activeVehicle);
    widgets.forEach(function (widget) {
      var variant = widget.getAttribute("data-garage-widget-variant") || "sidebar";
      if (variant === "inline") {
        if (activeVehicle) {
          widget.hidden = true;
          widget.innerHTML = "";
          return;
        }
        widget.hidden = false;
        widget.innerHTML = renderInlineCollectionWidget();
        return;
      }

      widget.hidden = false;
      widget.innerHTML = renderSidebarCollectionWidget(activeVehicle);
    });
  }

  function isGarageLimitReached() {
    return garageState.vehicles.length >= GARAGE_MAX_VEHICLES;
  }

  function notifyGarageLimitReached() {
    document.dispatchEvent(new CustomEvent("garage:vehicle-limit-reached", {
      detail: {
        limit: GARAGE_MAX_VEHICLES,
        currentCount: garageState.vehicles.length
      }
    }));
  }

  function renderGarageAccount() {
    var accountState = document.querySelector("[data-garage-account-state]");
    if (!accountState) return;
    if (garageState.available === false) {
      setGarageAccountVisible(false);
      accountState.innerHTML = "";
      return;
    }

    setGarageAccountVisible(true);
    var rowCapacity = window.innerWidth >= 1500 ? 4 : (window.innerWidth >= 1025 ? 3 : (window.innerWidth >= 761 ? 2 : 1));

    if (!garageState.loaded) {
      if (!shouldShowInitialGarageLoading()) {
        setGarageAccountVisible(false);
        accountState.innerHTML = "";
        return;
      }
      var loadingCards = "";
      for (var loadingIndex = 0; loadingIndex < rowCapacity; loadingIndex += 1) {
        loadingCards += '<article class="garage-account-loading-card" aria-hidden="true">' +
          '<span class="garage-account-loading-image"></span>' +
          '<span class="garage-account-loading-line is-title"></span>' +
          '<span class="garage-account-loading-line is-meta"></span>' +
          '<span class="garage-account-loading-line is-action"></span>' +
          '</article>';
      }
      accountState.innerHTML = '<div class="garage-account-loading" aria-busy="true" aria-label="Garaj yükleniyor">' + loadingCards + '</div>';
      return;
    }

    if (!garageState.vehicles.length) {
      accountState.innerHTML = '' +
        '<div class="garage-account-empty">' +
        '<div class="garage-account-empty-icon" aria-hidden="true">' + icon("garageEmpty") + '</div>' +
        '<p class="garage-account-empty-message">Aracını ekle, tüm ürünler aracına göre filtrelensin. Sana özel öneriler ve fırsatları kaçırma.</p>' +
        '<button class="garage-account-empty-add" type="button" data-garage-open-flow><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M6.66659 0.833008V12.4997M0.833252 6.66634H12.4999" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>İlk Aracını ekle</button>' +
        '</div>';
      return;
    }

    var cards = garageState.vehicles.map(function (vehicle) {
      var isActive = vehicle.id === garageState.activeId;
      var isActivating = vehicle.id === garageState.activatingId;
      var actionClass = isActive ? "" : " is-passive";
      var title = escapeHtml(vehicleTitle(vehicle));
      var makeModel = escapeHtml(vehicleMakeModel(vehicle));
      var meta = escapeHtml(vehicleMeta(vehicle));
      var hasNickname = Boolean(vehicle.nickname);
      return '<article class="garage-account-vehicle-card ' + (isActive ? "is-active" : "") + (hasNickname ? " has-nickname" : " is-unnamed") + '">' +
        '<button class="garage-account-vehicle-edit" type="button" data-garage-edit-vehicle="' + vehicle.id + '">Düzenle</button>' +
        '<img class="garage-account-vehicle-image" src="' + escapeAttr(vehicle.image) + '" alt="' + escapeAttr(vehicleImageAlt(vehicle)) + '">' +
        '<div class="garage-account-vehicle-side">' +
        '<div class="garage-account-vehicle-main"><h2>' + title + '</h2>' +
        (hasNickname && makeModel ? '<p class="garage-account-vehicle-model">' + makeModel + '</p>' : '') +
        (meta ? '<p>' + meta + '</p>' : '') +
        '</div>' +
        '<div class="garage-account-vehicle-actions" aria-label="Araç aksiyonları">' +
        '<button class="garage-account-action garage-account-action-check' + actionClass + (isActivating ? " is-loading" : "") + '" type="button" data-garage-set-active="' + vehicle.id + '" aria-label="Aktif yap"' + (isActivating || isActive ? ' disabled' : '') + (isActivating ? ' aria-busy="true"' : '') + '>' + icon("statusCheck") + '</button>' +
        '<button class="garage-account-action garage-account-action-trash" type="button" data-garage-delete-vehicle="' + vehicle.id + '" aria-label="Sil">' + icon("trash") + '</button>' +
        '</div>' +
        '<button class="garage-account-vehicle-cta" type="button" data-garage-products-url="' + escapeAttr(vehicle.productsUrl || "") + '" data-garage-products-vehicle="' + escapeAttr(vehicle.id) + '">Aracına Uygun Lastikler ' + icon("ctaArrow") + '</button>' +
        '</div>' +
        '</article>';
    }).join("");

    var slots = "";
    var slotCount = 0;
    var vehicleCount = garageState.vehicles.length;

    if (vehicleCount < GARAGE_MAX_VEHICLES) {
      if (vehicleCount < rowCapacity) {
        slotCount = rowCapacity - vehicleCount;
      } else {
        // Satır dolu olsa da limit dolana kadar bir "Araç Ekle" kartı görünür.
        slotCount = 1;
      }
    }
    for (var i = 0; i < slotCount; i += 1) {
      slots += '<button class="garage-account-add-slot" type="button" data-garage-open-flow>' + icon("addVehicle") + 'Araç Ekle</button>';
    }

    accountState.innerHTML = '<div class="garage-account-filled">' + cards + slots + '</div>';
  }

  function removeVehicleById(deleteId) {
    if (!deleteId) return;
    garageState.vehicles = garageState.vehicles.filter(function (vehicle) {
      return vehicle.id !== deleteId;
    });
    if (!garageState.vehicles.length) {
      garageState.activeId = null;
    } else if (!getActiveVehicle()) {
      garageState.activeId = garageState.vehicles[0].id;
    }
    updateGarageButtons();
    renderGarageMenu();
    renderCollectionWidgets();
    renderGarageAccount();
  }

  function vehicleApiId(vehicleId) {
    var vehicle = garageState.vehicles.find(function (item) {
      return item.id === String(vehicleId);
    });
    return vehicle ? vehicle.apiId : vehicleId;
  }

  function normalizedKm(value) {
    var digits = String(value || "").replace(/\D/g, "").slice(0, 9);
    return digits ? Number(digits) : null;
  }

  function formatVehiclePlate(value) {
    var clean = String(value || "").toUpperCase().replace(/[^0-9A-Z]/g, "").slice(0, 9);
    var provinceMatch = clean.match(/^\d{0,2}/);
    var province = provinceMatch ? provinceMatch[0] : "";
    var rest = clean.slice(province.length);
    var letterMatch = rest.match(/^[A-Z]{0,3}/);
    var letters = letterMatch ? letterMatch[0] : "";
    var serial = rest.slice(letters.length).replace(/\D/g, "").slice(0, 4);
    return [province, letters, serial].filter(Boolean).join(" ");
  }

  function formatVehicleKm(value) {
    var digits = String(value || "").replace(/\D/g, "").slice(0, 9);
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  function vehicleEventPayload(vehicle) {
    return {
      id: vehicle.id,
      brand: vehicle.brand,
      model: vehicle.model,
      nickname: vehicle.nickname,
      displayName: vehicle.displayName,
      year: vehicle.year,
      engineName: vehicle.engineName,
      tire: vehicle.tireDisplay || vehicle.tire,
      image: vehicle.image
    };
  }

  function dispatchVehicleSaved(newVehicleId) {
    var newVehicle = garageState.vehicles.find(function (vehicle) {
      return vehicle.id === String(newVehicleId);
    }) || getActiveVehicle() || garageState.vehicles[0];

    if (!newVehicle) return;

    document.dispatchEvent(new CustomEvent("garage:vehicle-saved", {
      detail: {
        brand: newVehicle.brand,
        model: newVehicle.model,
        title: vehicleTitle(newVehicle),
        year: newVehicle.year,
        engine: {
          id: newVehicle.id,
          name: newVehicle.engineName,
          tire: newVehicle.tireDisplay || newVehicle.tire
        },
        newVehicleId: newVehicle.id,
        totalVehicles: garageState.vehicles.length,
        activeId: garageState.activeId,
        vehicles: garageState.vehicles.map(vehicleEventPayload)
      }
    }));
  }

  function createVehicle(detail) {
    var previousIds = garageState.vehicles.map(function (vehicle) {
      return vehicle.id;
    });
    var engineId = detail.engine && detail.engine.id ? String(detail.engine.id) : "";
    var payload = {
      label: detail.nickname || null,
      plate: detail.plate || null,
      current_km: normalizedKm(detail.km)
    };

    if (/^\d+$/.test(engineId)) {
      payload.vehicle_engine_id = Number(engineId);
      payload.primary_tire_size = detail.engine ? detail.engine.tire : null;
    } else {
      payload.make_name = detail.brand;
      payload.model_name = detail.model;
      payload.year = Number(detail.year);
      payload.engine_name = detail.engine ? detail.engine.name : null;
      payload.primary_tire_size = detail.engine ? detail.engine.tire : null;
    }

    return garageRequest("/vehicles", {
      method: "POST",
      body: JSON.stringify(payload)
    }).then(function (payload) {
      hydrateGarage(payload);
      var newVehicle = garageState.vehicles.find(function (vehicle) {
        return previousIds.indexOf(vehicle.id) === -1;
      });
      dispatchVehicleSaved(newVehicle ? newVehicle.id : garageState.activeId);
      closeModal();
    });
  }

  function updateVehicle(detail) {
    if (!detail.id) return Promise.resolve();
    return garageRequest("/vehicles/" + encodeURIComponent(vehicleApiId(detail.id)), {
      method: "PATCH",
      body: JSON.stringify({
        label: detail.nickname || null,
        plate: detail.plate || null,
        current_km: normalizedKm(detail.km),
        last_tire_change_date: detail.lastTireChange || null
      })
    }).then(hydrateGarage);
  }

  function deleteVehicle(vehicleId) {
    if (!vehicleId) return Promise.resolve();
    return garageRequest("/vehicles/" + encodeURIComponent(vehicleApiId(vehicleId)), {
      method: "DELETE",
      body: JSON.stringify({})
    }).then(hydrateGarage);
  }

  function renderActivationLoading() {
    renderGarageMenu();
    renderGarageAccount();
  }

  function activateVehicle(vehicleId) {
    vehicleId = String(vehicleId || "");
    if (!vehicleId || vehicleId === garageState.activeId || garageState.activatingId) return Promise.resolve();

    garageState.activatingId = vehicleId;
    renderActivationLoading();

    return garageRequest("/vehicles/" + encodeURIComponent(vehicleApiId(vehicleId)) + "/activate", {
      method: "POST",
      body: JSON.stringify({})
    }).then(function (payload) {
      garageState.activatingId = null;
      hydrateGarage(payload);
      document.dispatchEvent(new CustomEvent("garage:vehicle-switched", { detail: getActiveVehicle() }));
    }, function (error) {
      garageState.activatingId = null;
      renderActivationLoading();
      throw error;
    });
  }

  function renderProgress() {
    var progress = "";
    for (var i = 0; i < stepTitles.length; i += 1) {
      var cls = "";
      if (i < state.step) cls = "is-complete";
      if (i === state.step) cls = "is-active";
      progress += '<span class="' + cls + '"></span>';
    }
    els.progress.innerHTML = progress;
  }

  function setStep(nextStep) {
    state.step = nextStep;
    render();
  }

  function filterItems(items, query, getText) {
    var q = (query || "").trim().toLocaleLowerCase("tr");
    if (!q) return items;
    return items.filter(function (item) {
      return getText(item).toLocaleLowerCase("tr").indexOf(q) > -1;
    });
  }

  function selectedCheckIcon() {
    return icon("check").replace('class="garage-modal-check"', 'class="garage-modal-selected-check"');
  }

  function renderSelectedChoice(label, value, meta, badge) {
    if (!value) return "";
    var badgeHtml = badge ? '<div class="garage-modal-selected-meta"><span class="garage-modal-selected-badge"><span>' + escapeHtml(String(badge)) + '</span></span></div>' : "";
    var sideClass = "garage-modal-selected-side" + (badgeHtml ? "" : " is-check-only");
    return '<div class="garage-modal-selected">' +
      '<span class="garage-modal-label">' + escapeHtml(label) + '</span>' +
      '<div class="garage-modal-selected-card">' +
      '<span class="garage-modal-selected-main"><strong>' + escapeHtml(value) + '</strong>' + (meta ? '<small>' + escapeHtml(meta) + '</small>' : '') + '</span>' +
      '<div class="' + sideClass + '">' + badgeHtml + selectedCheckIcon() + '</div>' +
      '</div>' +
      '</div>';
  }

  function getBrandById(brandId) {
    return garageData.brands.find(function (brand) {
      return brand.id === brandId;
    }) || null;
  }

  function modelValue(model) {
    return typeof model === "string" ? model : String(model.id || model.slug || model.name);
  }

  function modelLabel(model) {
    return typeof model === "string" ? model : model.name;
  }

  function yearValue(year) {
    return typeof year === "string" ? year : year.year;
  }

  function tireValue(tire) {
    return typeof tire === "string" ? tire : tire.value;
  }

  function renderBrandSections(query) {
    var searchQuery = (query || "").trim();
    if (searchQuery) {
      return '<div class="garage-modal-brand-block">' +
        '<span class="garage-modal-label">Markalar</span>' +
        '<div class="garage-modal-grid is-all-brands" data-garage-options-search>' + brandButtons(filterItems(garageData.brands, searchQuery, function (brand) {
          return brand.name;
        }), "search") + '</div>' +
        '</div>';
    }

    var popularBrands = garageData.brands.filter(function (brand) {
      return brand.popular;
    });
    var allBrands = garageData.brands.filter(function (brand) {
      return !brand.popular;
    });
    var selectedBrand = getBrandById(state.brand);
    var showAllBrands = state.showAllBrands || state.lockAllBrands || Boolean(selectedBrand && !selectedBrand.popular);

    return '<div class="garage-modal-brand-block">' +
      '<span class="garage-modal-label">Popüler Markalar</span>' +
      '<div class="garage-modal-grid" data-garage-options-popular>' + brandButtons(popularBrands, "popular") + '</div>' +
      '</div>' +
      (showAllBrands ? '<div class="garage-modal-brand-block">' +
        '<span class="garage-modal-label">Tüm Markalar</span>' +
        '<div class="garage-modal-grid is-all-brands" data-garage-options-all>' + brandButtons(allBrands, "all") + '</div>' +
        '</div>' : '');
  }

  function renderBrandStep() {
    var selectedBrand = getBrandById(state.brand);
    var selectedBrandIsRequiredAll = Boolean(selectedBrand && !selectedBrand.popular);
    return '' +
      '<div class="garage-modal-search">' + icon("search") + '<input type="search" data-garage-search placeholder="Marka ara..."></div>' +
      renderSelectedChoice("Seçili marka", selectedBrand ? selectedBrand.name : "") +
      '<div class="garage-modal-brand-sections" data-garage-brand-sections>' +
      renderBrandSections("") +
      '</div>' +
      (!state.lockAllBrands && !selectedBrandIsRequiredAll ? '<button class="garage-modal-footer-link" type="button" data-garage-toggle-brands>' + (state.showAllBrands ? "Tüm Markaları Gizle" : "Tüm Markalar (A-Z)") + ' ' + icon("down") + '</button>' : '') +
      '<button class="garage-modal-primary" type="button" data-garage-next>Devam Et</button>';
  }

  function brandButtons(brands, source) {
    if (!brands.length) return '<div class="garage-modal-empty">Sonuç bulunamadı.</div>';
    return brands.map(function (brand) {
      return '<button class="garage-modal-option ' + (state.brand === brand.id ? "is-selected" : "") + '" type="button" data-garage-brand="' + escapeAttr(brand.id) + '" data-garage-brand-source="' + escapeAttr(source || "popular") + '">' + escapeHtml(brand.name) + '</button>';
    }).join("");
  }

  function renderModelStep() {
    var models = garageData.models[state.brand] || [];
    var listClass = models.length > 5 ? "garage-modal-list is-scroll-models" : "garage-modal-list";
    if (referenceState.modelsLoading) {
      return '<div class="garage-modal-empty">Modeller yükleniyor...</div>';
    }
    return '' +
      '<div class="garage-modal-search">' + icon("search") + '<input type="search" data-garage-search placeholder="Model ara..."></div>' +
      renderSelectedChoice("Seçili model", state.modelName || state.model || "") +
      '<div class="' + listClass + '" data-garage-options>' + modelButtons(models) + '</div>' +
      '<button class="garage-modal-primary" type="button" data-garage-next>Devam Et</button>';
  }

  function modelButtons(models) {
    if (!models.length) return '<div class="garage-modal-empty">Sonuç bulunamadı.</div>';
    return models.map(function (model) {
      var value = modelValue(model);
      var label = modelLabel(model);
      return '<button class="garage-modal-option ' + (state.model === value ? "is-selected" : "") + '" type="button" data-garage-model="' + escapeAttr(value) + '" data-garage-model-name="' + escapeAttr(label) + '"><span>' + escapeHtml(label) + '</span>' + icon("check") + '</button>';
    }).join("");
  }

  function renderYearStep() {
    if (referenceState.yearsLoading) {
      return '<div class="garage-modal-empty">Yıllar yükleniyor...</div>';
    }
    var yearGridClass = garageData.years.length > 16 ? "garage-modal-grid is-years is-scroll-years" : "garage-modal-grid is-years";
    return renderSelectedChoice("Seçili yıl", state.year || "") +
      '<div class="' + yearGridClass + '">' + garageData.years.map(function (year) {
        var value = String(yearValue(year));
        var modelId = typeof year === "string" ? "" : year.modelId;
        return '<button class="garage-modal-option ' + (state.year === value ? "is-selected" : "") + '" type="button" data-garage-year="' + escapeAttr(value) + '" data-garage-model-id="' + escapeAttr(modelId) + '">' + escapeHtml(value) + '</button>';
      }).join("") + '</div><button class="garage-modal-primary" type="button" data-garage-next>Devam Et</button>';
  }

  function renderEngineStep() {
    if (referenceState.enginesLoading) {
      return '<div class="garage-modal-empty">Motorlar yükleniyor...</div>';
    }
    var engineListClass = garageData.engines.length > 3 ? "garage-modal-list is-scroll-engines" : "garage-modal-list";
    return renderSelectedChoice("Seçili motor", state.engine ? state.engine.name : "", state.engine ? state.engine.detail : "") +
      '<div class="' + engineListClass + '">' + garageData.engines.map(function (engine) {
        var detail = engine.detail ? '<small>' + escapeHtml(engine.detail) + '</small>' : "";
        return '<button class="garage-modal-engine ' + (state.engine && state.engine.id === engine.id ? "is-selected" : "") + '" type="button" data-garage-engine="' + escapeAttr(engine.id) + '">' +
          '<span><strong>' + escapeHtml(engine.name) + '</strong>' + detail + '</span></button>';
      }).join("") + '</div>' +
      '<button class="garage-modal-primary" type="button" data-garage-next>Devam Et</button>';
  }

  function renderTireStep() {
    if (referenceState.tireSizesLoading) {
      return renderSelectedChoice("Seçili motor", state.engine ? state.engine.name : "", state.engine ? state.engine.detail : "", state.engine ? state.engine.tire : "") +
        '<div class="garage-modal-empty">Lastik ebatları yükleniyor...</div>';
    }

    if (state.engineManualOpen) return renderEngineManualStep();

    var selectedTire = state.selectedTire ? state.selectedTire.value : (state.engine ? state.engine.tire : "");
    var selectedTireOption = garageData.tireSizes.find(function (tire) {
      return tireValue(tire) === selectedTire;
    });
    var selectedTireMeta = selectedTireOption ? (selectedTireOption.isStock ? "Standart ebat" : "Alternatif ebat") : "";
    var tireListClass = garageData.tireSizes.length > 3 ? "garage-modal-list is-scroll-tires" : "garage-modal-list";

    return renderSelectedChoice("Seçili motor", state.engine ? state.engine.name : "", state.engine ? state.engine.detail : "", state.engine ? state.engine.tire : "") +
      renderSelectedChoice("Seçili ebat", selectedTire, selectedTireMeta) +
      '<button class="garage-modal-manual-entry" type="button" data-garage-open-manual-tire>' +
      '<span class="garage-modal-manual-entry-left"><img src="' + assetHref("assets/svg/keyboard.svg") + '" alt=""><span>Lastik ebatını kendim girmek istiyorum</span></span>' +
      '<img class="garage-modal-manual-entry-arrow" src="' + assetHref("assets/svg/blue-arrow.svg") + '" alt="">' +
      '</button>' +
      '<div class="' + tireListClass + '">' + garageData.tireSizes.map(function (tire) {
        var value = tireValue(tire);
        var stock = tire.isStock ? '<small>Standart ebat</small>' : '<small>Alternatif ebat</small>';
        return '<button class="garage-modal-tire ' + (selectedTire === value ? "is-selected" : "") + '" type="button" data-garage-tire="' + escapeAttr(value) + '">' +
          '<span><strong>' + escapeHtml(value) + '</strong>' + stock + '</span>' +
          (selectedTire === value ? icon("check") : "") +
          '</button>';
      }).join("") + '</div>' +
      '<button class="garage-modal-primary" type="button" data-garage-next>Devam Et</button>';
  }

  function sanitizeTirePart(value, maxLen) {
    return String(value || "").replace(/\D/g, "").slice(0, maxLen);
  }

  function getManualConstruction() {
    var symbol = String(state.manualTire.construction || tireConstructionOptions[0] || "R").toUpperCase();
    return tireConstructionOptions.indexOf(symbol) > -1 ? symbol : tireConstructionOptions[0];
  }

  function manualTireCode() {
    if (!state.manualTire.width || !state.manualTire.aspect || !state.manualTire.rim) return "";
    return state.manualTire.width + "/" + state.manualTire.aspect + getManualConstruction() + state.manualTire.rim;
  }

  function isManualTireReady() {
    return Boolean(state.manualTire.width && state.manualTire.aspect && state.manualTire.rim);
  }

  function renderEngineManualStep() {
    var construction = getManualConstruction();
    var constructionControl =
      '<div class="garage-modal-manual-construction-wrap" data-garage-manual-construction-wrap>' +
      '<button class="garage-modal-manual-divider garage-modal-manual-construction-trigger" type="button" data-garage-manual-construction-trigger aria-label="Karkas tipi seç" aria-expanded="' + (state.manualConstructionMenuOpen ? "true" : "false") + '">' +
      '<span class="garage-modal-manual-construction-value">' + construction + '</span>' +
      '</button>' +
      (tireConstructionOptions.length > 1 && state.manualConstructionMenuOpen
        ? ('<div class="garage-modal-manual-construction-menu" role="listbox" aria-label="Karkas tipi">' +
          tireConstructionOptions.filter(function (item) { return item !== construction; }).map(function (item) {
            return '<button class="garage-modal-manual-construction-option" type="button" data-garage-manual-construction-option="' + item + '">' + item + '</button>';
          }).join("") +
          '</div>')
        : '') +
      '<input type="hidden" name="manual_tire_construction" data-garage-manual-construction-hidden value="' + construction + '">' +
      '</div>';

    return '' +
      '<div class="garage-modal-manual-card">' +
      '<strong>Lastik ebatını girin</strong>' +
      '<small>Lastik yan duvarındaki kodu bulun. Örnek: 205/55R16</small>' +
      '</div>' +
      '<div class="garage-modal-manual-preview">' +
      '<div class="garage-modal-manual-preview-track">' +
      '<strong class="garage-modal-manual-preview-values"><span data-garage-preview-width>' + (state.manualTire.width || "205") + '</span><span class="garage-modal-manual-preview-sep">/</span><span data-garage-preview-aspect>' + (state.manualTire.aspect || "55") + '</span><span class="garage-modal-manual-preview-sep" data-garage-preview-construction>' + construction + '</span><span data-garage-preview-rim>' + (state.manualTire.rim || "16") + '</span></strong>' +
      '<div class="garage-modal-manual-preview-legend"><span>Genişlik</span><span>Kesit</span><span>Jant Çapı</span></div>' +
      '</div>' +
      '</div>' +
      '<div class="garage-modal-manual-inputs">' +
      '<div class="garage-modal-manual-input-group"><span>Genişlik</span><input type="text" inputmode="numeric" maxlength="3" data-garage-manual-width id="manual_tire_width" name="manual_tire_width" autocomplete="off" value="' + state.manualTire.width + '"></div>' +
      '<span class="garage-modal-manual-divider">/</span>' +
      '<div class="garage-modal-manual-input-group"><span>Kesit</span><input type="text" inputmode="numeric" maxlength="2" data-garage-manual-aspect id="manual_tire_aspect" name="manual_tire_aspect" autocomplete="off" value="' + state.manualTire.aspect + '"></div>' +
      constructionControl +
      '<div class="garage-modal-manual-input-group"><span>Jant Çapı</span><input type="text" inputmode="numeric" maxlength="2" data-garage-manual-rim id="manual_tire_rim" name="manual_tire_rim" autocomplete="off" value="' + state.manualTire.rim + '"></div>' +
      '</div>' +
      '<input type="hidden" data-garage-manual-code name="manual_tire_code" value="' + manualTireCode() + '">' +
      '<button class="garage-modal-primary garage-modal-manual-continue' + (isManualTireReady() ? "" : " is-disabled") + '" type="button" data-garage-apply-manual-tire ' + (isManualTireReady() ? "" : "disabled") + '>Devam Et</button>';
  }

  function syncManualPreview() {
    if (!els.overlay || !state.engineManualOpen) return;
    var widthEl = els.overlay.querySelector("[data-garage-preview-width]");
    var aspectEl = els.overlay.querySelector("[data-garage-preview-aspect]");
    var rimEl = els.overlay.querySelector("[data-garage-preview-rim]");
    var constructionEl = els.overlay.querySelector("[data-garage-preview-construction]");
    var hiddenConstructionEl = els.overlay.querySelector("[data-garage-manual-construction-hidden]");
    var codeEl = els.overlay.querySelector("[data-garage-manual-code]");
    var continueButton = els.overlay.querySelector("[data-garage-apply-manual-tire]");
    if (widthEl) widthEl.textContent = state.manualTire.width || "205";
    if (aspectEl) aspectEl.textContent = state.manualTire.aspect || "55";
    if (rimEl) rimEl.textContent = state.manualTire.rim || "16";
    if (constructionEl) constructionEl.textContent = getManualConstruction();
    if (hiddenConstructionEl) hiddenConstructionEl.value = getManualConstruction();
    if (codeEl) codeEl.value = manualTireCode();
    if (!continueButton) return;
    var ready = isManualTireReady();
    continueButton.disabled = !ready;
    continueButton.classList.toggle("is-disabled", !ready);
  }

  function renderSaveStep() {
    var engine = state.engine || garageData.engines[0];
    var tire = state.selectedTire ? state.selectedTire.value : (engine && engine.tire ? engine.tire : "");
    return '<div class="garage-modal-summary"><div class="garage-modal-car"><img src="' + assetHref("assets/images/sample-car.png") + '" alt=""></div><div class="garage-modal-summary-text"><strong>' + getBrandName() + ' ' + (state.modelName || state.model) + '</strong><span>' + state.year + ' - ' + engine.name.replace(/\s*\([^)]*\)/, "") + ' - ' + tire + '</span></div></div>' +
      '<span class="garage-modal-label">Opsiyonel Bilgiler</span>' +
      '<div class="garage-modal-fields">' +
      '<input class="garage-modal-field" type="text" maxlength="80" autocomplete="off" data-garage-nickname placeholder="Aracına isim ver (Ör: Aile Aracı)">' +
      '<input class="garage-modal-field" type="text" inputmode="text" autocomplete="off" maxlength="11" data-garage-plate placeholder="Plaka (opsiyonel)">' +
      '<input class="garage-modal-field" type="text" inputmode="numeric" autocomplete="off" maxlength="11" data-garage-km placeholder="Güncel KM (opsiyonel)">' +
      '</div><button class="garage-modal-primary is-save" type="button" data-garage-save>Aracımı Kaydet</button>';
  }

  function render() {
    els.title.textContent = stepTitles[state.step];
    els.title.style.display = state.step === 5 ? "none" : "";
    var backText = selectedSummary();
    els.back.innerHTML = state.step > 0 ? icon("back") + '<span>' + backText + '</span>' : "";
    els.back.classList.toggle("is-visible", state.step > 0 && state.step < 5);
    els.modal.classList.toggle("is-compact", state.step >= 2);
    els.modal.classList.toggle("is-final", state.step === 5);
    renderProgress();

    if (state.step === 0) els.body.innerHTML = renderBrandStep();
    if (state.step === 1) els.body.innerHTML = renderModelStep();
    if (state.step === 2) els.body.innerHTML = renderYearStep();
    if (state.step === 3) els.body.innerHTML = renderEngineStep();
    if (state.step === 4) els.body.innerHTML = renderTireStep();
    if (state.step === 5) els.body.innerHTML = renderSaveStep();
  }

  function resetFlow() {
    state.step = 0;
    state.brand = null;
    state.model = null;
    state.modelName = null;
    state.modelId = null;
    state.year = null;
    state.engine = null;
    state.selectedTire = null;
    state.tireSizesEngineId = null;
    state.engineManualOpen = false;
    state.creatingVehicle = false;
    state.manualConstructionMenuOpen = false;
    state.manualTire = { width: "", aspect: "", rim: "", construction: tireConstructionOptions[0] };
    state.showAllBrands = false;
    state.lockAllBrands = false;
    referenceState.tireSizesLoading = false;
    garageData.tireSizes = [];
  }

  function openModal() {
    if (garageState.available !== true || !els.overlay) return;
    closeGarageMenu();
    resetFlow();
    render();
    loadBrands().then(function () {
      if (state.step === 0 && els.overlay && els.overlay.classList.contains("is-open")) render();
    }).catch(function () { });
    els.overlay.classList.add("is-open");
    els.overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("garage-modal-open");
    setTimeout(function () {
      var input = els.overlay.querySelector("input, button");
      if (input) input.focus();
    }, 0);
  }

  function closeModal() {
    if (!els.overlay) return;
    els.overlay.classList.remove("is-open");
    els.overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("garage-modal-open");
  }

  function tryOpenAddVehicleFlow() {
    if (garageState.available !== true) return;
    if (garageState.loaded && !garageState.authenticated) {
      window.location.href = window.KOLAYOTO_GARAGE_LOGIN_URL || "/account/login";
      return;
    }
    if (isGarageLimitReached()) {
      notifyGarageLimitReached();
      return;
    }
    openModal();
  }

  function nextStep() {
    if (state.step === 0 && !state.brand) return;
    if (state.step === 1 && !state.model) return;
    if (state.step === 2 && !state.year) return;
    if (state.step === 3 && !state.engine) return;
    if (state.step === 3) {
      setStep(4);
      if (state.engine && state.tireSizesEngineId !== String(state.engine.id)) {
        loadTireSizesForEngine(state.engine.id).catch(function () { });
      }
      return;
    }
    if (state.step === 4) {
      if (state.engineManualOpen || !state.selectedTire) return;
      if (state.engine && state.selectedTire) {
        state.engine.tire = state.selectedTire.value;
        state.engine.tireOptions = garageData.tireSizes.slice();
      }
    }
    setStep(Math.min(state.step + 1, 5));
  }

  function bindEvents() {
    document.addEventListener("click", function (event) {
      var homeHeroTab = event.target.closest(".garage-home-hero__tab");
      if (homeHeroTab) {
        homeHeroTab.closest(".garage-home-hero__tabs").querySelectorAll(".garage-home-hero__tab").forEach(function (tab) {
          tab.classList.toggle("is-active", tab === homeHeroTab);
        });
        return;
      }

      var homeHeroMode = event.target.closest(".garage-home-hero__mode");
      if (homeHeroMode) {
        homeHeroMode.closest(".garage-home-hero__mode-tabs").querySelectorAll(".garage-home-hero__mode").forEach(function (mode) {
          mode.classList.toggle("is-active", mode === homeHeroMode);
        });
        return;
      }

      var homeHeroChevron = event.target.closest(".garage-home-hero__select-chevron");
      if (homeHeroChevron) {
        var selectControl = homeHeroChevron.closest(".garage-home-hero__select-control");
        var select = selectControl ? selectControl.querySelector("select") : null;
        if (!select) return;
        event.preventDefault();
        select.focus();
        if (typeof select.showPicker === "function") {
          select.showPicker();
        } else {
          select.click();
        }
        return;
      }

      var garageAction = event.target.closest("[data-garage-empty-menu-open], [data-garage-open-flow], [data-garage-modal-open], [data-garage-switch], [data-garage-set-active], [data-garage-edit-vehicle], [data-garage-delete-vehicle], [data-garage-products-url], [data-garage-filter-url], [data-garage-add-vehicle], [data-garage-home]");
      if (garageAction && garageState.available !== true) {
        event.preventDefault();
        return;
      }

      var emptyGaragePreview = event.target.closest("[data-garage-empty-menu-open]");
      if (emptyGaragePreview) {
        event.preventDefault();
        closeGarageMenu();
        garageMenuForceEmptyPreview = true;
        var garageToggleButton = visibleGarageToggleButton();
        var garageWrap = garageToggleButton ? garageToggleButton.closest(".garage-demo-garage") : null;
        if (!garageToggleButton || !garageWrap) return;
        garageWrap.classList.add("is-open");
        garageToggleButton.setAttribute("aria-expanded", "true");
        renderGarageMenu();
        return;
      }

      var addFlowOpener = event.target.closest("[data-garage-open-flow]");
      if (addFlowOpener) {
        event.preventDefault();
        tryOpenAddVehicleFlow();
        return;
      }

      var opener = event.target.closest("[data-garage-modal-open]");
      if (opener) {
        event.preventDefault();
        var garageMenuWrap = opener.closest(".garage-demo-garage");
        if (garageMenuWrap && garageMenuWrap.classList.contains("is-open")) {
          closeGarageMenu();
          return;
        }
        toggleGarageMenu(opener);
        return;
      }

      var switchButton = event.target.closest("[data-garage-switch]");
      if (switchButton) {
        activateVehicle(switchButton.getAttribute("data-garage-switch")).catch(function () { });
        return;
      }

      var accountActiveButton = event.target.closest("[data-garage-set-active]");
      if (accountActiveButton) {
        activateVehicle(accountActiveButton.getAttribute("data-garage-set-active")).catch(function () { });
        return;
      }

      var accountEditButton = event.target.closest("[data-garage-edit-vehicle]");
      if (accountEditButton) {
        var editId = accountEditButton.getAttribute("data-garage-edit-vehicle");
        var editVehicle = garageState.vehicles.find(function (vehicle) {
          return vehicle.id === editId;
        });
        if (editVehicle) {
          document.dispatchEvent(new CustomEvent("garage:request-edit", {
            detail: {
              id: editVehicle.id,
              title: editVehicle.brand + " " + editVehicle.model,
              spec: editVehicle.year + " · " + editVehicle.engineName + " · " + (editVehicle.tireDisplay || editVehicle.tire),
              nickname: editVehicle.nickname || "",
              plate: editVehicle.plate || "",
              km: editVehicle.km || "",
              lastTireChange: editVehicle.lastTireChange || ""
            }
          }));
        }
        return;
      }

      var accountDeleteButton = event.target.closest("[data-garage-delete-vehicle]");
      if (accountDeleteButton) {
        var deleteId = accountDeleteButton.getAttribute("data-garage-delete-vehicle");
        var deleteVehicle = garageState.vehicles.find(function (vehicle) {
          return vehicle.id === deleteId;
        });
        if (document.querySelector("[data-delete-confirm-overlay]")) {
          var deleteTitle = deleteVehicle ? vehicleTitle(deleteVehicle) : "Seçili araç";
          var deleteSpec = deleteVehicle ? [vehicleMakeModel(deleteVehicle), deleteVehicle.year, deleteVehicle.tireDisplay || deleteVehicle.tire].filter(Boolean).join(" · ") : "";
          document.dispatchEvent(new CustomEvent("garage:request-delete", {
            detail: {
              id: deleteId,
              title: deleteTitle,
              spec: deleteSpec,
              label: deleteSpec ? (deleteTitle + " · " + deleteSpec) : deleteTitle
            }
          }));
        } else {
          deleteVehicle(deleteId);
        }
        return;
      }

      var productsButton = event.target.closest("[data-garage-products-url]");
      if (productsButton) {
        var productsUrl = productsButton.getAttribute("data-garage-products-url");
        var productsVehicleId = productsButton.getAttribute("data-garage-products-vehicle");
        if (productsUrl && productsVehicleId && productsVehicleId !== garageState.activeId) {
          setLoadingButton(productsButton, true, "Aktifleştiriliyor");
          activateVehicle(productsVehicleId).then(function () {
            window.location.href = productsUrl;
          }, function () {
            setLoadingButton(productsButton, false);
          });
          return;
        }
        if (productsUrl) {
          window.location.href = productsUrl;
        }
        return;
      }

      var tireFilterButton = event.target.closest("[data-garage-filter-url]");
      if (tireFilterButton) {
        var tireFilterUrl = tireFilterButton.getAttribute("data-garage-filter-url");
        if (tireFilterUrl) {
          tireFilterButton.classList.add("is-loading");
          tireFilterButton.setAttribute("aria-busy", "true");
          tireFilterButton.disabled = true;
          window.location.href = tireFilterUrl;
        }
        return;
      }

      if (event.target.closest("[data-garage-add-vehicle]")) {
        tryOpenAddVehicleFlow();
        return;
      }

      if (event.target.closest("[data-garage-home]")) {
        closeGarageMenu();
        document.dispatchEvent(new CustomEvent("garage:home-clicked", { detail: { vehicles: garageState.vehicles, active: getActiveVehicle() } }));
        window.location.href = garagePageHref();
        return;
      }

      if (!event.target.closest(".garage-demo-garage")) {
        closeGarageMenu();
      }
    });

    els.overlay.addEventListener("click", function (event) {
      if (garageState.available !== true) return;
      if (event.target === els.overlay || event.target.closest("[data-garage-close]")) {
        if (state.creatingVehicle) return;
        closeModal();
        return;
      }

      if (
        state.step === 4 &&
        state.engineManualOpen &&
        state.manualConstructionMenuOpen &&
        !event.target.closest("[data-garage-manual-construction-wrap]")
      ) {
        state.manualConstructionMenuOpen = false;
        render();
        return;
      }

      var brand = event.target.closest("[data-garage-brand]");
      if (brand) {
        state.brand = brand.getAttribute("data-garage-brand");
        var selectedBrand = getBrandById(state.brand);
        if (selectedBrand && !selectedBrand.popular) {
          state.lockAllBrands = true;
          state.showAllBrands = true;
        } else {
          state.lockAllBrands = false;
        }
        state.model = null;
        state.modelName = null;
        state.modelId = null;
        state.year = null;
        state.engine = null;
        state.selectedTire = null;
        state.tireSizesEngineId = null;
        state.engineManualOpen = false;
        referenceState.tireSizesLoading = false;
        garageData.tireSizes = [];
        loadModelsForMake(state.brand).catch(function () { });
        render();
      }

      var model = event.target.closest("[data-garage-model]");
      if (model) {
        state.model = model.getAttribute("data-garage-model");
        state.modelName = model.getAttribute("data-garage-model-name") || state.model;
        state.modelId = null;
        state.year = null;
        state.engine = null;
        state.selectedTire = null;
        state.tireSizesEngineId = null;
        state.engineManualOpen = false;
        referenceState.tireSizesLoading = false;
        garageData.tireSizes = [];
        loadYearsForModel(state.brand, state.model).catch(function () { });
        render();
      }

      var year = event.target.closest("[data-garage-year]");
      if (year) {
        state.year = year.getAttribute("data-garage-year");
        state.modelId = year.getAttribute("data-garage-model-id") || state.modelId;
        state.engine = null;
        state.selectedTire = null;
        state.tireSizesEngineId = null;
        state.engineManualOpen = false;
        state.manualConstructionMenuOpen = false;
        state.manualTire = { width: "", aspect: "", rim: "", construction: tireConstructionOptions[0] };
        referenceState.tireSizesLoading = false;
        garageData.tireSizes = [];
        loadEnginesForModel(state.modelId).catch(function () { });
        render();
      }

      var engine = event.target.closest("[data-garage-engine]");
      if (engine) {
        var engineId = engine.getAttribute("data-garage-engine");
        state.engine = garageData.engines.find(function (item) {
          return item.id === engineId;
        });
        state.selectedTire = null;
        state.tireSizesEngineId = null;
        state.engineManualOpen = false;
        state.manualConstructionMenuOpen = false;
        garageData.tireSizes = [];
        render();
      }

      if (event.target.closest("[data-garage-toggle-brands]")) {
        state.showAllBrands = !state.showAllBrands;
        render();
      }

      if (event.target.closest("[data-garage-open-manual-tire]")) {
        state.engineManualOpen = true;
        state.manualConstructionMenuOpen = false;
        render();
      }

      var tireOption = event.target.closest("[data-garage-tire]");
      if (tireOption) {
        var tireValueAttr = tireOption.getAttribute("data-garage-tire");
        state.selectedTire = garageData.tireSizes.find(function (item) {
          return item.value === tireValueAttr;
        }) || {
          id: tireValueAttr,
          value: tireValueAttr,
          label: tireValueAttr,
          isStock: false
        };
        if (state.engine) state.engine.tire = state.selectedTire.value;
        if (state.engine) state.engine.tireOptions = garageData.tireSizes.slice();
        render();
      }

      if (event.target.closest("[data-garage-manual-construction-trigger]")) {
        state.manualConstructionMenuOpen = !state.manualConstructionMenuOpen;
        render();
      }

      var constructionOption = event.target.closest("[data-garage-manual-construction-option]");
      if (constructionOption) {
        state.manualTire.construction = String(constructionOption.getAttribute("data-garage-manual-construction-option") || "").toUpperCase();
        state.manualConstructionMenuOpen = false;
        render();
      }

      if (event.target.closest("[data-garage-apply-manual-tire]")) {
        if (!isManualTireReady()) return;
        var tire = manualTireCode();
        state.selectedTire = {
          id: "manual-" + tire,
          value: tire,
          label: tire,
          isManual: true
        };
        if (state.engine) {
          state.engine.tire = tire;
          state.engine.tireOptions = [{
            id: "manual-" + tire,
            value: tire,
            label: tire,
            isManual: true
          }];
        } else {
          state.engine = {
            id: "manual-" + tire,
            name: "Özel Ebat",
            detail: "Manuel",
            tire: tire,
            tireOptions: [{
              id: "manual-" + tire,
              value: tire,
              label: tire,
              isManual: true
            }]
          };
        }
        state.engineManualOpen = false;
        state.manualConstructionMenuOpen = false;
        setStep(5);
      }

      if (event.target.closest("[data-garage-next]")) nextStep();

      var saveButton = event.target.closest("[data-garage-save]");
      if (saveButton) {
        if (state.creatingVehicle) return;
        if (isGarageLimitReached()) {
          closeModal();
          notifyGarageLimitReached();
          return;
        }
        var detail = {
          brand: getBrandName(),
          model: state.modelName || state.model,
          year: state.year,
          engine: state.engine,
          nickname: els.overlay.querySelector("[data-garage-nickname]").value,
          plate: els.overlay.querySelector("[data-garage-plate]").value,
          km: els.overlay.querySelector("[data-garage-km]").value
        };
        state.creatingVehicle = true;
        setLoadingButton(saveButton, true, "Kaydediliyor");
        createVehicle(detail).then(function () {
          state.creatingVehicle = false;
        }, function () {
          state.creatingVehicle = false;
          setLoadingButton(saveButton, false);
        });
      }
    });

    els.back.addEventListener("click", function () {
      if (state.creatingVehicle) return;
      if (state.step === 4 && state.engineManualOpen && garageData.tireSizes.length) {
        state.engineManualOpen = false;
        state.manualConstructionMenuOpen = false;
        render();
        return;
      }
      if (state.step > 0) setStep(state.step - 1);
    });

    els.overlay.addEventListener("input", function (event) {
      if (event.target.matches("[data-garage-manual-width]")) {
        state.manualTire.width = sanitizeTirePart(event.target.value, 3);
        event.target.value = state.manualTire.width;
        syncManualPreview();
        return;
      }

      if (event.target.matches("[data-garage-manual-aspect]")) {
        state.manualTire.aspect = sanitizeTirePart(event.target.value, 2);
        event.target.value = state.manualTire.aspect;
        syncManualPreview();
        return;
      }

      if (event.target.matches("[data-garage-manual-rim]")) {
        state.manualTire.rim = sanitizeTirePart(event.target.value, 2);
        event.target.value = state.manualTire.rim;
        syncManualPreview();
        return;
      }

      if (event.target.matches("[data-garage-plate]")) {
        event.target.value = formatVehiclePlate(event.target.value);
        return;
      }

      if (event.target.matches("[data-garage-km]")) {
        event.target.value = formatVehicleKm(event.target.value);
        return;
      }

      if (!event.target.matches("[data-garage-search]")) return;
      if (state.step === 0) {
        var brandSections = els.overlay.querySelector("[data-garage-brand-sections]");
        if (brandSections) brandSections.innerHTML = renderBrandSections(event.target.value);
        return;
      }
      if (state.step === 1) {
        var modelOptions = els.overlay.querySelector("[data-garage-options]");
        if (!modelOptions) return;
        modelOptions.innerHTML = modelButtons(filterItems(garageData.models[state.brand] || [], event.target.value, function (model) {
          return typeof model === "string" ? model : model.name;
        }));
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && els.overlay.classList.contains("is-open") && !state.creatingVehicle) closeModal();
      if (event.key === "Escape") closeGarageMenu();
    });

    document.addEventListener("garage:confirm-delete", function (event) {
      if (garageState.available !== true) return;
      var detail = event.detail || {};
      if (!detail.id) return;
      deleteVehicle(detail.id).then(function () {
        document.dispatchEvent(new CustomEvent("garage:delete-finished", {
          detail: { id: detail.id }
        }));
      }, function (error) {
        document.dispatchEvent(new CustomEvent("garage:delete-failed", {
          detail: { id: detail.id, error: error }
        }));
      });
    });

    document.addEventListener("garage:confirm-edit", function (event) {
      if (garageState.available !== true) return;
      var detail = event.detail || {};
      if (!detail.id) return;
      updateVehicle(detail).then(function () {
        document.dispatchEvent(new CustomEvent("garage:edit-finished", {
          detail: { id: detail.id }
        }));
      }, function (error) {
        document.dispatchEvent(new CustomEvent("garage:edit-failed", {
          detail: { id: detail.id, error: error }
        }));
      });
    });

    document.addEventListener("garage:set-active-vehicle", function (event) {
      if (garageState.available !== true) return;
      var detail = event.detail || {};
      if (!detail.id) return;
      activateVehicle(detail.id).catch(function () { });
    });

    document.addEventListener("garage:saved-show-products", function () {
      var active = getActiveVehicle();
      if (active && active.productsUrl) {
        window.location.href = active.productsUrl;
      }
    });

    var resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        renderGarageAccount();
      }, 100);
    });
  }

  function mount() {
    var overlay = document.querySelector("[data-garage-modal]");
    if (!overlay) return;
    if (garageTestDisabledFromUrl()) clearStoredGarageTestCode();
    applyGarageStateFromUrl();
    els.overlay = overlay;
    els.modal = overlay.querySelector(".garage-modal");
    els.back = overlay.querySelector("[data-garage-back]");
    els.title = overlay.querySelector("[data-garage-title]");
    els.progress = overlay.querySelector("[data-garage-progress]");
    els.body = overlay.querySelector("[data-garage-body]");
    els.garageMenu = document.querySelector("[data-garage-menu]");
    setGarageHeaderVisible(true);
    setGarageWidgetsVisible(false);
    els.overlay.hidden = true;
    window.GarageModal = {
      open: tryOpenAddVehicleFlow,
      close: closeModal,
      isAvailable: function () {
        return garageState.available === true;
      }
    };
    if (window.history && window.history.pushState && !window.history.__garageVehicleFilterPatched) {
      var nativePushState = window.history.pushState;
      window.history.pushState = function () {
        var result = nativePushState.apply(this, arguments);
        scheduleVehicleFilterStateUpdate();
        return result;
      };
      window.history.__garageVehicleFilterPatched = true;
    }
    window.addEventListener("popstate", scheduleVehicleFilterStateUpdate);
    bindEvents();
    renderGarageMenu();
    updateGarageButtons();
    renderCollectionWidgets();
    renderGarageAccount();
    render();
    hydrateGarageFromCache();
    refreshGarage();

    // Keep external modal triggers stable (used by garage-other-modals.js)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
